import { render } from "./CoursesGridPage.vue?vue&type=template&id=91c24f7c"
import script from "./CoursesGridPage.vue?vue&type=script&lang=js"
export * from "./CoursesGridPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pavithram.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__